import { arrowBearing, heatOf } from "./radar";
import type { RadarGuess } from "./RadarScope";

/** The scope's log: every guess, newest first — the exact numbers behind the blips. */
export function RadarLog({ guesses, restored }: { guesses: RadarGuess[]; restored: number }) {
  const rows = guesses.map((g, i) => ({ g, n: i + 1 })).reverse();
  return (
    <div className="rd space-y-[5px]">
      {rows.map(({ g, n }) => {
        const deg = arrowBearing(g.dir);
        return (
          <div key={g.code} className={`rd-log-row ${n > restored ? "rd-log-new" : ""}`} data-heat={heatOf(g.pct)}>
            <span className="text-[11px] tabular-nums opacity-50">{String(n).padStart(2, "0")}</span>
            <span className="truncate font-bold">{g.name}</span>
            <span className="tabular-nums opacity-80">{g.km === 0 ? "ціль" : `${g.km.toLocaleString("uk-UA")} км`}</span>
            <span className="rd-heat flex justify-center" aria-label={g.dir}>
              {deg === null ? (
                "◎"
              ) : (
                <svg viewBox="0 0 12 12" width="14" height="14" style={{ transform: `rotate(${deg}deg)` }} aria-hidden="true">
                  <path d="M6 0.8 L10.4 10 L6 7.4 L1.6 10 Z" fill="currentColor" />
                </svg>
              )}
            </span>
            <span className="rd-heat text-right font-bold tabular-nums">{g.pct}%</span>
          </div>
        );
      })}
    </div>
  );
}
